import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="final-cta" data-id="element-63">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-64">
        <h2 data-id="element-65">Cada día sin página web es un día que pierdes clientes.</h2>
        <p data-id="element-66">
          Por $37 aprendes a resolver eso hoy — y nunca más dependes de nadie
          para tu presencia online.
        </p>
        <a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="cta-btn" data-id="element-67">
          SÍ, QUIERO APRENDER
        </a>
      </motion.div>
    </section>;
}